<template>
  <div>
    <div v-if="deviceList" class="uk-flex" style="flex-wrap: wrap;">
      <div v-for="(item, key) in deviceList" :key="key" class="dev-div border">
        <el-row>{{ deviceTypeConvert(key) }}</el-row>
        <el-row>
          <el-col :span="8" class="bd-r">{{ $t('public.total_num') }}</el-col>
          <el-col :span="16">{{ item && item.totalCount }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" class="bd-r">{{ $t('public.online') }}</el-col>
          <el-col :span="16">{{ item &&item.onLine }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" class="bd-r">{{ $t('public.offline') }}</el-col>
          <el-col :span="16">{{ item &&item.offLine }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" class="bd-r">{{ $t('public.stop') }}</el-col>
          <el-col :span="16">{{ item &&item.stopCount }}</el-col>
        </el-row>
        <el-row>
          <el-col :span="8" class="bd-r">{{ $t('public.unconfirm') }}</el-col>
          <el-col :span="16">{{ item &&item.unknownCount }}</el-col>
        </el-row>

        <pieEchart v-if="item" :chartData="setPieEchartData(item)"/>
        <el-empty v-else :description="$t('public.no_data')" style="height:200px;" :image-size="100"></el-empty>

        <el-button type="primary" style="width:100%" @click="handleDetail(key)">{{ $t('public.detail')}}</el-button>
      </div>
    </div>
    <el-empty v-else :description="$t('public.no_data')"></el-empty>

    <DeviceDetail v-if="isShowDetail" :isShow="isShowDetail"
     :sceneIds="sceneIds"
     :type="type"
     @close="isShowDetail = false"/>
  </div>
</template>
<script>
import { getDeviceList } from '@/api/modules/overview.js'
import { deviceTypeConvert, deviceStatusConvert } from '@/utils/convert.js'
import pieEchart from '@/components/echart/pieEchart.vue';
import DeviceDetail from '../deviceDetail.vue';

export default {
  props: {
    sceneIds: {
      type: Array,
      default: () => []
    }
  },
  components: {
    pieEchart,
    DeviceDetail
  },
  data(){
    return {
      deviceList: null,
      isShowDetail: false,
      type: '', // 查看详细时设备类型：是传感器还是网关...等

      deviceTypeConvert,
    }
  },
  // created(){
  //   console.log('sceneIds=', this.sceneIds)
  //   this.getDevices()
  // },
  methods: {
    getData(){
      if(this.sceneIds && this.sceneIds.length){
        this.getDevices()
      }else{
        this.deviceList = null
      }
    },
    getDevices(){
      console.log('this.sceneIds===', this.sceneIds)
      console.log('this.sceneIds.join()=', this.sceneIds.join())
      getDeviceList({ scenes: this.sceneIds.join() }).then(res => {
        if (res.state.code === 200) {
          this.deviceList = res.result

        }
      })
    },
    setPieEchartData(item){
      // 整理构造饼图数据
      let pieSeries = []

      for(let key in item){
        if(key !== 'totalCount'){
          pieSeries.push({
            name: deviceStatusConvert(key),
            value: item[key]
          })
        }
      }
      return {
        pieSeries,
        rest: {
          legend: {
              show: false
          },
          isTip: true,
          labelLine: {
              show: true
          },
          label: {
              show: true
          },
          title: '',
          name: ''
        }
      }
    },
    handleDetail(key){
      this.type = key
      this.isShowDetail = true
    }
  }
}
</script>
<style lang="scss" scoped>
.dev-div {
  width: 280px;
  text-align: center;
  margin: 10px;
  flex-shrink: 0;
  .el-row {
    height: 30px;
    line-height: 30px;
    border-bottom: 1px solid #CCCCCC;;
  }
}

.echarts {
  width: 100%;
  height: 200px !important;
}

</style>
